import api from "@/config/api"
const platform = localStorage.getItem('platform')

export default {
    components: {
    },
    model: {
        prop: 'url',
        event: 'change'
    },
    props: ['url', 'num', 'data'],
    data() {
        return {
            maxNum: 1,
            headers: {},
            uploadUrl: `${api.baseUrl}/${platform}/open/upload_file`,
            loading: false,
            previewVisible: false,
            previewImage: '',
            fileList: [],
            type: 2, //类型： 2-图片 3-视频
            materials: [],
            types: [],
        }
    },
    computed: {
    },
    watch: {
        url(value) {
            if (this.fileList.length > 0) {
                return
            }
            const items = typeof (value) === 'string' ? [value] : value
            this.setUrl(items)
        },
        materials() {
            //同步主组件值
            this.$emit('afterUpload', this.materials);
            // console.log('qqqqqqqqqqqqqqqqqqqqqq:this.materials',this.materials)
        },
        fileList: {
            handler(items) {
                let urls = []
                for (let i = 0; i < items.length; i++) {
                    let item = items[i]
                    const response = item.response
                    const message = response && response.message || '上传失败'

                    if (item.status === 'done' && response && response.code !== 0) {
                        this.$message.destroy()
                        this.$message.error(message)
                        this.fileList.splice(i, 1)
                        continue
                    }

                    const url = item.url || (response && response.data && response.data.url)

                    if (url) {
                        urls.push(url)
                        items[i] = {
                            uid: item.uid,
                            name: item.name,
                            status: item.status,
                            url: url,
                            returnData: (response && response.data) ? response.data : null
                        }
                        if (response && response.data) {
                            if (!Array.isArray(this.materials)) {
                                this.materials = []
                            }
                            this.materials.push(response.data)
                            // this.types[response.data.url] = response.data.type
                            this.types[`${response.data.url}`] = response.data.type
                        }
                    }
                    

                    if (['uploading', 'done'].includes(item.status)) {
                        continue
                    }

                    this.fileList.splice(i, 1)
                    this.materials.splice(i, 1)
                    this.$message.destroy()
                    this.$message.error(message)
                }
                if (this.maxNum === 1) {
                    urls = urls[0]
                }
                this.$emit('change', urls)
                // console.log('yyyyyyyyyyyyyyyyyyy',this.fileList)
                // console.log('当前的fileList：',this.fileList)
            },
            deep: true
        }
    },
    mounted() {
        this.url && this.setUrl(this.url)
        this.maxNum = this.num || this.maxNum
        this.headers['Access-Token'] = localStorage.getItem('token')
    },
    methods: {
        handleCancel() {
            this.previewVisible = false
        },
        async handlePreview(file) {
            this.previewImage = file.url || file.response.data.url
            this.previewVisible = true
        },
        handleChange({ fileList }) {
            // if (file.percent == 100 && file.response && file.response.data) {
            //     // 在这里触发自定义事件，并将需要返回的数据作为参数传递
            //     let afterUpload = file.response.data
            //     this.$emit('afterUpload', afterUpload);
            // }
            //此处改为fileList绑定
            this.fileList = fileList
            if (this.fileList.length <= 0) {
                this.materials = {}
            }
        },
        remove (item) {
            //移除this.materials里面url=item.url 的元素
            this.materials = this.materials.filter(obj => obj.url !== item.url);  
        },
        beforeUpload(file) {
            if (file.type.includes('image')) {
                this.type = 2
                const allowTypes = [
                    'image/jpg',
                    'image/jpeg',
                    'image/png',
                    'image/gif',
                ]

                const isImage = allowTypes.includes(file.type)

                if (!isImage) {
                    file.response = { code: -1, message: '图片格式错误' }
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isLt2M) {
                    file.response = { code: -1, message: '图片大小不能超过 10MB' }
                }
                return !!(isLt2M)
            } else {
                this.type = 3
                // file.response = { code: -1, message: '暂不支持视频' }
                // return false
                const isLt2M = file.size / 1024 / 1024 <= 500;

                if (!isLt2M) {
                    file.response = { code: -1, message: '图片大小不能超过 500MB' }
                }
                return !!(isLt2M)
            }

        },
        setUrl(items) {
            if (!items) {
                return
            }
            if (typeof (items) === 'string') {
                items = [items]
            }
            for (let i = 0; i < items.length; i++) {
                this.fileList.push({
                    uid: (new Date()).getTime() + i,
                    name: 'image.png',
                    status: 'done',
                    url: items[i],
                })
            }
        }
    }
}
